<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Paul T. Mascia is a <i class="calibre1">cum laude</i> graduate of Yale University, where he majored in Religious Studies. His senior thesis was an in-depth analysis of the reformer and Medieval mystic, St Catherine of Siena. Paul has attained over thirty years of experience as an insurance professional with an expertise in the fields of both long-term care and disability insurance. He has a certification in long term care planning (CLTC). Paul and his wife, Theresa, currently live in Columbus, OH. They have five adult children and seven grandchildren. <i class="calibre1">Nazar’s Journey</i> is Mr. Mascia’s first novel, and his first piece of historical fiction. His work aims to realise two important goals during this season of his life: a desire to utilise his creative skills in new ways, as well as to draw attention to the sufferings of displaced peoples in diverse parts of the globe, particularly those facing severe adversity due to their religious beliefs.</p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?db4573d4